export default "__VITE_ASSET__CqE8SjgI__"